<template>
    <div class="outer">
        <div class="meta-box">
            <h1>Users</h1>
        </div>
        <c-table
            v-if="headerSet && isRegistered"
            data-service-repository="users"
            data-columns='[{"field":"email","header":"Email"}, {"field":"name","header":"Name"}, {"field":"role","header":"Role"}]'
            v-bind:data-inline-create="canCreateNewUsers"
            data-avoid-toast-on-submit
            data-component-on-expand="probac-info-for-user"
        >
        </c-table>
    </div>
</template>

<script setup lang="ts">
import "@/wc/registry/component/table/index.js";
import "@/wc/probac-info-for-user/index.js";
import { computed, ref } from "vue";
import { headerManager } from "@/lib/requests";
import { useRepository } from "@/composables/repository";
import { useUserManager } from "@/stores/user-store";

const { isRegistered } = useRepository("users");
const { user } = useUserManager();

const canCreateNewUsers = computed(() => {
    return user.value?.role === "user-manager";
});

const { organizationHeaderSet } = headerManager;
const headerSet = ref(false);
organizationHeaderSet.then(() => {
    headerSet.value = true;
});
</script>

<style scoped lang="css">
.outer {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    padding: 10px;
}

c-table::part(th-is_admin) {
    width: 50px;
}

c-table::part(add-row-wrapper) {
    justify-content: flex-start;
}
</style>
